import React from 'react';
import styled from 'styled-components';
import HeaderEs from '../common/header/HeaderEs';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { reqEsDetailInfoAction } from '../../modules/od/orderModule';
import Modal from 'react-modal';
import NormalPopup, { customModalStyles } from '../common/popup/NormalPopup';
import { delEsItemAction, updateEsItemStatusAction } from '../../modules/es/esItemModule';
import EsReqDvryInfoWait from './EsReqDvryInfoWait';
import {
    EsReqMustGuide, EsReqDvryInfo, EsReqDvryGuide,
    EsReqRefund,EsComItemList, EsComSummary
}
    from './'
import {isMobileOnly} from 'react-device-detect';

// Modal Stryle
export const EsReqInfoPopupModalStyles = {
    content: {
        padding: isMobileOnly?"0":"20px",
        /* top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '10%',
        transform: 'translate(-50%, -50%)', */
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        marginRight: 'auto',
        postion: 'fixed',


        zIndex: '999',
        overlay: 'auto',
        WebkitOverflowScrolling: 'touch',
        width: "100%",
        height: "100%",
        borderRadius: '0px',
        backgroundColor: '#fff',
        borderWidth: '0px',
    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: '1000'
    }
};

const EsReqInfoPopupBlock = styled.div`
  ${isMobileOnly&&`margin: 0 4vw;`};
  .mobile-header {margin:40px; text-align: center;}

`;

const EsReqInfoWrapBlock = styled.div`
    padding: 98px 0 179px;  
    width: 100%;
    max-width: 1176px;
    margin: 0 auto;
`;
const EsReqInfoMobileWrapBlock = styled.div`
  
    padding-bottom: 170px;
    // .splitter {border-bottom: 2px solid #ececec; padding-bottom:10px;}
    .product-table {
      margin: 10px 0;
      border-top: 2px solid #111;  
    }    
`;

const EsReqInfoPopup = ({ esItem, onCloseClick }) => {

    const history = useHistory();
    const dispatch = useDispatch();
    const [msg, setMsg] = useState(null);
    const [openModal, setOpenModal] = useState(false);

    const { es_rqst_id, pckg_nm, rqst_date_format, brnd_han, rqst_price,
        es_dscnt_total_price, es_prdct_total_price, es_final_price,
        expr_date, es_dlvry_total_price, es_detail_dlvry_pay_type, total_qty,
        es_pay_price, dsrd_date_format, rqst_status, cancel_date_format } = esItem[0];

    var { esItemDetailInfo, esStatusRes } = useSelector(
        ({ esOrderReducer, esItemsReducer }) => ({
            esItemDetailInfo: esOrderReducer.esItemDetailInfo,
            esStatusRes: esItemsReducer.esStatusRes,
        })
    );

    useEffect(() => {
        dispatch(reqEsDetailInfoAction(es_rqst_id))
    }, [])

    useEffect(() => {
        //console.log('esItemDetailInfo = ' + JSON.stringify(esItemDetailInfo));
    }, [esItemDetailInfo])

    useEffect(() => {
        //console.log('esStatusRes = ' + JSON.stringify(esStatusRes));
        if(esStatusRes !== null && esStatusRes*1 ===200) {
            //console.log('esStatusRes222 = ' + JSON.stringify(esStatusRes));
            setOpenModal(false);
            history.replace('/es');
            //onCloseClick();
        }
    }, [esStatusRes])

    const statusMsg = <div className="es_apply_info-box">
        <p className="eai-title margin_b-30">
            견적 요청 중이예요. 조금만 더 기다려 주세요.
        </p>
        견적 요청 시 중간 수정이 불가하며<br/>
        판매자가 회원님께 제안한 견적서는 [가구견적] 메뉴에서 확인 가능합니다.
        <p className="margin_b-30 margin_t-30">
            견적 요청일 : 
            <span className="font-mont"> {rqst_date_format}</span>
        </p>
        <span>상기 내용을 확인했습니다.</span>
    </div>

    const getStatusMsg = () => {
        if(rqst_status==='050101' || rqst_status==='050102' || rqst_status==='050103') {
            return (
            <div className="es_apply_info-box">
                <p className="eai-title margin_b-10">
                견적 요청중이예요. 조금만 기다려주세요🧐
                </p>
                견적 요청 시 중간 수정이 불가합니다.<br/>
                <p className="margin_t-20 margin_b-30">
                    견적 요청일 : 
                    <span className="font-mont"> {rqst_date_format}</span>
                </p>
                <span>위 내용을 확인했습니다.</span>
            </div>   
        )
             
        } else if(rqst_status==='050104') {
            return (
                <div className="es_apply_info-box">
                <p className="eai-title margin_b-10">
                견적 진행중이예요. 조금만 더 기다려주세요😉
                </p>
                견적 진행 시 중간 수정이 불가합니다.<br/>
                <p className="margin_b-30 margin_t-20">
                    견적 요청일 : 
                    <span className="font-mont"> {rqst_date_format}</span>
                </p>
                <span>위 내용을 확인했습니다.</span>
            </div>    
            )  
        } else if(rqst_status==='050110') {
            return (
                <div className="es_apply_info-box">
                <p className="eai-title margin_b-10">
                요청중인 견적 요청서가 취소처리 되었어요😢
                </p>
                새로운 견적을 알아볼까요?<br/>
                <p className="margin_t-20 margin_b-5">
                    요청일 : 
                    <span className="font-mont"> {rqst_date_format}</span>
                </p>
                <p className="margin_b-30">
                    취소일 : 
                    <span className="font-mont"> {cancel_date_format}</span>
                </p>
            </div> 
            )  
        } 
        else if(rqst_status==='050111') {
            return (
                <div className="es_apply_info-box">
                <p className="eai-title margin_b-10">
                정상 견적서가 취소처리 되었어요😢
                </p>
                새로운 견적을 알아볼까요?<br/>
                <p className="margin_t-20 margin_b-5">
                    견적일 : 
                    <span className="font-mont"> {rqst_date_format}</span>
                </p>
                <p className="margin_b-30">
                    취소일 : 
                    <span className="font-mont"> {cancel_date_format}</span>
                </p>
            </div>   
            )  
        } 
        else {
            return (
                <div className="es_apply_info-box">
                    <p className="eai-title margin_b-30">
                        견적 요청 중이예요. 조금만 더 기다려 주세요.
                    </p>
                    견적 요청 시 중간 수정이 불가하며<br/>
                    판매자가 회원님께 제안한 견적서는 [가구견적] 메뉴에서 확인 가능합니다.
                    <p className="margin_b-30 margin_t-30">
                        견적 요청일 :
                        <span className="font-mont"> {rqst_date_format}</span>
                    </p>
                    <span>상기 내용을 확인했습니다.</span>
                </div>   
            )  
        } 
    }

    const handleClickCancelBtn = () => {
        setMsg("견적서가 취소됩니다.\n견적취소하시겠습니까?");
        setOpenModal(true);
    }

    const handleModalClose = () => {
        setOpenModal(false);
    }

    // 확인
    const handleModalBtn1Click = () => {
        dispatch(updateEsItemStatusAction(es_rqst_id,"050110")); //050110 -> 견적취소
    }

    // 닫기
    const handleModalBtn2Click = () => {
        setOpenModal(false);
    }

    return (<EsReqInfoPopupBlock>
          {isMobileOnly?
            <div className="flex vc fe">
                <div className="mobile-header title-xl font-bold margin_b-40 margin_t-40 flex-1 text_center">{brnd_han}</div>
                < i className="fas fa-times fa-2x" onClick={onCloseClick}/>
            </div>
            :
            <HeaderEs
              rqst_id={es_rqst_id} name={brnd_han}
              onCloseClick={onCloseClick}
            />
          }
          {isMobileOnly ?
            <EsReqInfoMobileWrapBlock>
                <div className="title-lg margin_b-30">
                    {pckg_nm}
                </div>
                <div className="flex vc jsb">
                    <div>{es_rqst_id}</div>
                    <div>견적요청일: {rqst_date_format}</div>
                </div>

                <div className="margin_b-80">
                    <EsComItemList items={esItem}/>
                </div>
                <EsComSummary item={esItem[0]} type="responsive"/>

                {/*<EsReqMustGuide*/}
                {/*  detailInfo={esItemDetailInfo}/>*/}

                <EsReqDvryInfo detailInfo={esItemDetailInfo}
                               dsrd_date_format={dsrd_date_format} rqst_status={rqst_status}/>
                {getStatusMsg()}

            </EsReqInfoMobileWrapBlock>
            :
            <EsReqInfoWrapBlock>
                <div className="es_title-box margin_b-80">
                    <h3 className="es_title margin_b-30">
                        {pckg_nm}
                    </h3>
                    <div className="save_pay-box clearfix">
                        <span className="f-left">총 상품 금액</span>
                        <span className="save_pay f-right"><span className="font-mont">
                        {Number(es_prdct_total_price.toFixed(1)).toLocaleString()}</span>원</span>
                    </div>
                </div>

                <div className="margin_b-80">
                    <div className="filter-top myes_top clearfix">
                        <span className="f-left">견적 요청일 <span className="font-mont">{rqst_date_format}</span></span>
                    </div>

                    <div className="product-table default-table">
                        <table>
                            <colgroup>
                                <col width="120px;"/>
                                <col width="710px;"/>
                                <col width="124px;"/>
                                <col width="221px;"/>
                            </colgroup>

                            <thead>
                            <tr>
                                <th colSpan="2">상품 정보</th>
                                <th>수량</th>
                                <th>판매금액</th>
                            </tr>
                            </thead>
                            <tbody>
                                <EsComItemList items={esItem}/>
                            </tbody>
                            <EsComSummary item={esItem[0]} type="tableTr"/>
                        </table>
                    </div>

                    {/*<EsReqDvryInfoWait detailInfo={esItemDetailInfo}*/}
                    {/*                   rqst_date_format={rqst_date_format} dsrd_date_format={dsrd_date_format}/>*/}

                    <EsReqDvryInfo detailInfo={esItemDetailInfo}
                                   dsrd_date_format={dsrd_date_format} rqst_status={rqst_status}/>

                    {getStatusMsg()}
                </div>

            </EsReqInfoWrapBlock>
          }
          {rqst_status==='050102' ? 
            <div className="full_popup_btn-wrap">
                    <button type="button" className="mh-btn gray-btn" onClick={handleClickCancelBtn}>견적 취소</button>
            </div>
          :
          ''
          }
          <Modal
                isOpen={openModal}
                onRequestClose={handleModalClose}
                style={customModalStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {
                    <NormalPopup
                        text=""
                        text2={msg}
                        btn1="예" btn2="아니오"
                        onClick1={handleModalBtn1Click}
                        onClick2={handleModalBtn2Click} />
                }

            </Modal>
      </EsReqInfoPopupBlock>
    );
};

export default EsReqInfoPopup;
